<template functional>
  <div
    class="dataset-cell-digit"
    v-bind="data.attrs"
    :class="[data.staticClass, props.class]"
  >
    {{ $options.enable(props)}}
  </div>
</template>

<script>
import IMask from 'imask'
import ModuleBase from './module-base'


export default {
  name: 'DatasetCellDigit',
  mixins: [ModuleBase],
  // face
  enable: (props) => {
   
    const mask = IMask.createMask({
      mask: Number, // enable number mask

      // other options are optional with defaults below
      scale: props.value < 1000 ? 0 : props.value > 1000 && props.value < 9999 ? 3 : 0, // digits after point, 0 for integers
      signed: false, // disallow negative
      thousandsSeparator: ',', // any single char
      padFractionalZeros: true, // if true, then pads zeros at end to the length of scale
      normalizeZeros: false, // appends or removes zeros at ends
      radix: props.value < 1000  ? '' : ',', // fractional delimiter
      mapToRadix: [','], // symbols to process as radix

      // additional number interval options (e.g.)
      // min: -10000,
      // max: 10000
    })
    
     return mask.resolve(String(props.value ))
    
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.dataset-cell-digit {
  font-weight: $weight-medium;
}
</style>

